// export const ACTIVATE_ALERT_ASYNC = 'ACTIVATE_ALERT_ASYNC';
export const ACTIVATE_ALERT = 'ACTIVATE_ALERT';
export const DEACTIVATE_ALERT = 'DEACTIVATE_ALERT';
